module.exports = __webpack_public_path__ + "static/img/zhong14.63b4c32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhong14.png
// module id = H4Zy
// module chunks = 16